/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  ResultOfIEnumerableOfAllowedRulesResponseModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfIEnumerableOfAllowedRulesResponseModelFromJSON,
    ResultOfIEnumerableOfAllowedRulesResponseModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface AllowedRulesGetAllowedRulesRequest {
    parentLuType: string;
    parentValue?: string | null;
    childLuType?: string | null;
}

/**
 * 
 */
export class AllowedRulesApi extends runtime.BaseAPI {

    /**
     * Get allowed rules.
     */
    async allowedRulesGetAllowedRulesRaw(requestParameters: AllowedRulesGetAllowedRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIEnumerableOfAllowedRulesResponseModel>> {
        if (requestParameters.parentLuType === null || requestParameters.parentLuType === undefined) {
            throw new runtime.RequiredError('parentLuType','Required parameter requestParameters.parentLuType was null or undefined when calling allowedRulesGetAllowedRules.');
        }

        const queryParameters: any = {};

        if (requestParameters.parentValue !== undefined) {
            queryParameters['parentValue'] = requestParameters.parentValue;
        }

        if (requestParameters.childLuType !== undefined) {
            queryParameters['childLuType'] = requestParameters.childLuType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/rules/allowed-rules/{parentLuType}`.replace(`{${"parentLuType"}}`, encodeURIComponent(String(requestParameters.parentLuType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIEnumerableOfAllowedRulesResponseModelFromJSON(jsonValue));
    }

    /**
     * Get allowed rules.
     */
    async allowedRulesGetAllowedRules(requestParameters: AllowedRulesGetAllowedRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIEnumerableOfAllowedRulesResponseModel> {
        const response = await this.allowedRulesGetAllowedRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
